import { render, staticRenderFns } from "./mutiOrderLicense.vue?vue&type=template&id=6fec0f33&scoped=true"
import script from "./mutiOrderLicense.vue?vue&type=script&lang=js"
export * from "./mutiOrderLicense.vue?vue&type=script&lang=js"
import style0 from "./mutiOrderLicense.vue?vue&type=style&index=0&id=6fec0f33&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fec0f33",
  null
  
)

export default component.exports